import { useQuery } from '@tanstack/react-query';
import { selectedOfficeService } from '~/domain/SelectedOffice';
import { useAppSelector } from '~/hooks/useAppSelector';
import type { IUser } from '~/models/User';
import { locationSettingsKeys } from './locationSettingsKeys';
import { selectKnownOffice } from './selectKnownOffice';

/**
 * One location's office record, read with that location's `x-office` so it
 * does not depend on what the switcher has selected. The selected office or
 * the signed-in one, already in redux, shows as placeholder data until the read
 * lands (`isPlaceholderData`). It is never seeded as the record itself: under
 * the office-read flag the signed-in record has its office fields stripped
 * unless it is the selected office, so it can't stand in for a fetched one.
 */
export const useOfficeProfile = (officeId: string) => {
  const knownRecord = useAppSelector(selectKnownOffice(officeId));

  return useQuery<IUser>({
    queryKey: locationSettingsKeys.office(officeId),
    queryFn: () => selectedOfficeService.getSelectedOffice({ officeId }),
    placeholderData: knownRecord,
    enabled: !!officeId,
  });
};
